import * as Sentry from '@sentry/nuxt'
import { startServiceWorkerUpdates } from '~/utils/serviceWorkerUpdates'

export default defineNuxtPlugin({
  name: 'advisor:pwa-updates',
  // Install the hook before the PWA module's post plugin registers its worker.
  enforce: 'pre',
  setup(nuxtApp) {
    let stop: (() => void) | undefined
    nuxtApp.hook('service-worker:activated', ({ url, registration }) => {
      stop?.()
      if (!registration) {
        return
      }
      stop = startServiceWorkerUpdates(url, registration, (error) => {
        Sentry.captureException(error, { tags: { failure_reason: 'service_worker_update' } })
      })
    })
    if (import.meta.hot) {
      import.meta.hot.dispose(() => stop?.())
    }
  },
})
